module.exports = __webpack_public_path__ + "img/cb.4c4b6df4.svg";